import { Divider } from 'antd';

export type infoIds = {
  receiptId: string;
  customerId: string;
  warehouseId: string;
  paypalOrderId?: string;
};

function CustomerIDInforComponent({ infoIds }: { infoIds: infoIds }) {
  return (
    <div
      style={{
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'space-around'
      }}
    >
      <div style={{ marginTop: '20px' }}>
        <p style={{ marginBottom: '30px' }}>
          <b>Customer ID</b>
        </p>
        <p style={{ marginBottom: '30px' }}>
          <b>Warehouse ID</b>
        </p>
        <p style={{ marginBottom: '30px' }}>
          <b>Receipt ID</b>
        </p>
        {infoIds?.paypalOrderId && (
          <p>
            <b>Billing Invoice No.</b>
          </p>
        )}
      </div>
      <Divider type="vertical" style={{ height: '200px' }} />
      <div style={{ marginTop: '20px' }}>
        <p style={{ marginBottom: '30px' }}>{infoIds?.customerId}</p>
        <p style={{ marginBottom: '30px' }}>{infoIds?.warehouseId}</p>
        <p style={{ marginBottom: '30px' }}>{infoIds?.receiptId}</p>
        {infoIds?.paypalOrderId && <p>{infoIds?.paypalOrderId}</p>}
      </div>
    </div>
  );
}

export default CustomerIDInforComponent;
